"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var S = __importStar(require("./LftDivider.styles"));
var LftDivider = function (_a) {
    var _b = _a.ariaHidden, ariaHidden = _b === void 0 ? true : _b, bgColor = _a.bgColor, dataTestId = _a.dataTestId, _c = _a.orientation, orientation = _c === void 0 ? "horizontal" : _c, className = _a.className, style = _a.style;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(S.Divider, { "aria-hidden": ariaHidden, "data-lift": "lft-divider", "data-testid": dataTestId, bgColor: bgColor, orientation: orientation, className: className, style: style }, void 0) }, void 0));
};
exports.default = LftDivider;
